/* eslint-disable */
// Do not edit this directly !!!!!!!!!!!!!!!
// File was generated using API/scripts/build_permission_tree.js
// To recreate go to /API and type npm run buildpermissions

import _ from 'lodash'
export const TestPermission = function (list, permission) {
  if (_.startsWith(permission, 'ANY:')) {
    const permParts = permission.split(':')
    return _.filter(list, (p) => { return _.startsWith(p, permParts[1]) }).length > 0
  } else {
    return _.find(list, (p) => { return p === permission }) === permission
  }
}
export const TestPermissions = function (list, permissions, requireAll = false) {
  if (permissions.length === 0) {
    return true
  }

  if (requireAll) {
    let matchCount = 0
    for (var perm of permissions) {
      isMatch = TestPermission(list, perm)
      if (isMatch === true) {
        matchCount++
      }
    }
    return permissions.length == matchCount
  } else {
    let isMatch = false
    for (var perm of permissions) {
      isMatch = TestPermission(list, perm)
      if (isMatch === true) {
        break
      }
    }
    return isMatch
  }
}
export const Permissions = {
  Admin: {
    ANY: 'ANY:Admin',
    Common: {
      ANY: 'ANY:Admin.Common',
      ManageSystemSettings: 'Admin.Common.ManageSystemSettings',
      ViewDashboard: 'Admin.Common.ViewDashboard'
    },
    DataSetup: {
      ANY: 'ANY:Admin.DataSetup',
      ManageCountries: 'Admin.DataSetup.ManageCountries',
      ManageLocations: 'Admin.DataSetup.ManageLocations',
      ManageReportDefinitionCategories: 'Admin.DataSetup.ManageReportDefinitionCategories',
      ManageReportDefinitions: 'Admin.DataSetup.ManageReportDefinitions',
      ManageStates: 'Admin.DataSetup.ManageStates'
    },
    Security: {
      ANY: 'ANY:Admin.Security',
      AddLogin: 'Admin.Security.AddLogin',
      ManageLogins: 'Admin.Security.ManageLogins',
      ManagePositions: 'Admin.Security.ManagePositions',
      ManageRoles: 'Admin.Security.ManageRoles',
      ManageDoors: 'Admin.Security.ManageDoors'
    },
    Tools: {
      ANY: 'ANY:Admin.Tools',
      ManageAPIDevices: 'Admin.Tools.ManageAPIDevices',
      ManageFingerPrintCache: 'Admin.Tools.ManageFingerPrintCache',
      ManageLoginDomains: 'Admin.Tools.ManageLoginDomains',
      ManageNotificationTemplates: 'Admin.Tools.ManageNotificationTemplates',
      SearchErrorLog: 'Admin.Tools.SearchErrorLog'
    },
    ALL: [
      'Admin.Common.ManageSystemSettings',
      'Admin.Common.ViewDashboard',
      'Admin.DataSetup.ManageCountries',
      'Admin.DataSetup.ManageLocations',
      'Admin.DataSetup.ManageReportDefinitionCategories',
      'Admin.DataSetup.ManageReportDefinitions',
      'Admin.DataSetup.ManageStates',
      'Admin.Security.AddLogin',
      'Admin.Security.ManageLogins',
      'Admin.Security.ManagePositions',
      'Admin.Security.ManageRoles',
      'Admin.Tools.ManageAPIDevices',
      'Admin.Tools.ManageFingerPrintCache',
      'Admin.Tools.ManageLoginDomains',
      'Admin.Tools.ManageNotificationTemplates',
      'Admin.Tools.SearchErrorLog'
    ]
  },
  Employee: {
    ANY: 'ANY:Employee',
    Common: {
      ANY: 'ANY:Employee.Common',
      ManagePersonnel: 'Employee.Common.ManagePersonnel',
      ManagePosition: 'Employee.Common.ManagePosition',
      ViewDashboard: 'Employee.Common.ViewDashboard',
      ManageOrganization: 'Employee.Common.ManageOrganization'
    },
    DataSetup: {
      ANY: 'ANY:Employee.DataSetup',
      ManageEmployeeCustomFields: 'Employee.DataSetup.ManageEmployeeCustomFields',
      ManageTerminationReasons: 'Employee.DataSetup.ManageTerminationReasons',
      MangePositionTemplate: 'Employee.DataSetup.MangePositionTemplate',
      MangeTime: 'Employee.DataSetup.MangeTime'
    },
    ALL: [
      'Employee.Common.ManagePersonnel',
      'Employee.Common.ManagePosition',
      'Employee.Common.ViewDashboard',
      'Employee.Common.ManageOrganization',
      'Employee.DataSetup.ManageEmployeeCustomFields',
      'Employee.DataSetup.ManageTerminationReasons',
      'Employee.DataSetup.MangePositionTemplate'
    ]
  },
  Inventory: {
    ANY: 'ANY:Inventory',
    Common: {
      ANY: 'ANY:Inventory.Common',
      AddNewStockItem: 'Inventory.Common.AddNewStockItem',
      ManageStockItems: 'Inventory.Common.ManageStockItems',
      MakeRequisitions: 'Inventory.Common.MakeRequisitions',
      ApproveRequisitions: 'Inventory.Common.ApproveRequisitions',
      ProcessLPO: 'Inventory.Common.ProcessLPO',
      MakeItemRequest: 'Inventory.Common.MakeItemRequest',
      ApproveItemIssue: 'Inventory.Common.ApproveItemIssue',
      ItemIssue: 'Inventory.Common.ItemIssue',
      StoreTransfer: 'Inventory.Common.StoreTransfer',
      InventoryAdjustment: 'Inventory.Common.InventoryAdjustment'
    },
    DataSetup: {
      ANY: 'ANY:Inventory.Datasetup',
      SetupInventory: 'Inventory.DataSetup.SetupInventory'
    },
    ALL: [
      'Inventory.Common.AddNewStockItem',
      'Inventory.Common.ManageStockItems',
      'Inventory.DataSetup.ApproveRequisitions',
      'Inventory.DataSetup.ProcessLPO',
      'Inventory.DataSetup.ApproveItemIssue',
      'Inventory.DataSetup.ItemIssue',
      'Inventory.DataSetup.StoreTransfer',
      'Inventory.DataSetup.InventoryAdjustment'
    ]
  },
  Office: {
    ANY: 'ANY:Office',
    Common: {
      ANY: 'ANY:Office.Common',
      AssignAllAssets: 'Office.Common.AssignAllAssets',
      DecommissionAllAssets: 'Office.Common.DecommissionAllAssets',
      ManageAllAssets: 'Office.Common.ManageAllAssets',
      ManageAllRooms: 'Office.Common.ManageAllRooms',
      ProcessAllAssetRequests: 'Office.Common.ProcessAllAssetRequests',
      ProcessAllRoomRequests: 'Office.Common.ProcessAllRoomRequests',
      ViewDashboard: 'Office.Common.ViewDashboard',
      StoreReturn: 'Office.Common.StoreReturn'
    },
    DataSetup: {
      ANY: 'ANY:Office.DataSetup',
      ManageAssetCustomFields: 'Office.DataSetup.ManageAssetCustomFields',
      ManageAssetGroups: 'Office.DataSetup.ManageAssetGroups',
      ManageAssetServiceTypes: 'Office.DataSetup.ManageAssetServiceTypes',
      ManageBuildings: 'Office.DataSetup.ManageBuildings',
      ManageRoomCategories: 'Office.DataSetup.ManageRoomCategories',
      ManageRoomGroups: 'Office.DataSetup.ManageRoomGroups',
      ManageRoomServiceTypes: 'Office.DataSetup.ManageRoomServiceTypes',
      ManageRoomTypes: 'Office.DataSetup.ManageRoomTypes',
      ManageStockItemCategories: 'Office.DataSetup.ManageStockItemCategories',
      ManageStockItemTypes: 'Office.DataSetup.ManageStockItemTypes'
    },
    Tools: {
      ANY: 'ANY:Office.Tools',
      ScheduleAllRooms: 'Office.Tools.ScheduleAllRooms',
      ServiceAllRooms: 'Office.Tools.ServiceAllRooms'
    },
    ALL: [
      'Office.Common.AssignAllAssets',
      'Office.Common.DecommissionAllAssets',
      'Office.Common.ManageAllAssets',
      'Office.Common.ManageAllRooms',
      'Office.Common.ProcessAllAssetRequests',
      'Office.Common.ProcessAllRoomRequests',
      'Office.Common.ViewDashboard',
      'Office.DataSetup.ManageAssetCustomFields',
      'Office.DataSetup.ManageAssetGroups',
      'Office.DataSetup.ManageAssetServiceTypes',
      'Office.DataSetup.ManageBuildings',
      'Office.DataSetup.ManageRoomCategories',
      'Office.DataSetup.ManageRoomGroups',
      'Office.DataSetup.ManageRoomServiceTypes',
      'Office.DataSetup.ManageRoomTypes',
      'Office.DataSetup.ManageStockItemCategories',
      'Office.DataSetup.ManageStockItemTypes',
      'Office.Tools.ScheduleAllRooms',
      'Office.Tools.ServiceAllRooms',
      'Office.Common.StoreReturn'
    ]
  },
  SelfService: {
    ANY: 'ANY:SelfService',
    Common: {
      ANY: 'ANY:SelfService.Common',
      ManageAssets: 'SelfService.Common.ManageAssets',
      ManageHome: 'SelfService.Common.ManageHome',
      ManageProfile: 'SelfService.Common.ManageProfile',
      ManageVisitorAppointments: 'SelfService.Common.ManageVisitorAppointments',
      ViewCalendar: 'SelfService.Common.ViewCalendar'
    },
    ALL: [
      'SelfService.Common.ManageAssets',
      'SelfService.Common.ManageHome',
      'SelfService.Common.ManageProfile',
      'SelfService.Common.ManageVisitorAppointments',
      'SelfService.Common.ViewCalendar'
    ]
  },
  Vehicles: {
    ANY: 'ANY:Vehicles',
    ThirdParty: {
      ANY: 'ANY:Vehicles.3rdParty',
      ManageInsuranceProviders: 'Vehicles.ThirdParty.ManageInsuranceProviders',
      ManageServiceShops: 'Vehicles.ThirdParty.ManageServiceShops',
      ManageVendors: 'Vehicles.3rdParty.ManageVendors'
    },
    Common: {
      ANY: 'ANY:Vehicles.Common',
      AssignAllVehicles: 'Vehicles.Common.AssignAllVehicles',
      DecommissionAllVechiles: 'Vehicles.Common.DecommissionAllVechiles',
      ManageAllVehicles: 'Vehicles.Common.ManageAllVehicles',
      ProcessAllVehicleRequests: 'Vehicles.Common.ProcessAllVehicleRequests',
      ScheduleAllVehicles: 'Vehicles.Common.ScheduleAllVehicles',
      ViewDashboard: 'Vehicles.Common.ViewDashboard'
    },
    DataSetup: {
      ANY: 'ANY:Vehicles.DataSetup',
      ManageCustomFields: 'Vehicles.DataSetup.ManageCustomFields',
      ManageInsurancePolicies: 'Vehicles.DataSetup.ManageInsurancePolicies',
      ManageMakes: 'Vehicles.DataSetup.ManageMakes',
      ManageModels: 'Vehicles.DataSetup.ManageModels',
      ManageRegistrationTypes: 'Vehicles.DataSetup.ManageRegistrationTypes',
      ManageServiceTypes: 'Vehicles.DataSetup.ManageServiceTypes',
      ManageTypes: 'Vehicles.DataSetup.ManageTypes',
      ManageVehicleGroups: 'Vehicles.DataSetup.ManageVehicleGroups'
    },
    Trackers: {
      ANY: 'ANY:Vehicles.Trackers',
      ManageTrackers: 'Vehicles.Trackers.ManageTrackers'
    },
    ALL: [
      'Vehicles.3rdParty.ManageInsuranceProviders',
      'Vehicles.3rdParty.ManageServiceShops',
      'Vehicles.3rdParty.ManageVendors',
      'Vehicles.Common.AssignAllVehicles',
      'Vehicles.Common.DecommissionAllVechiles',
      'Vehicles.Common.ManageAllVehicles',
      'Vehicles.Common.ProcessAllVehicleRequests',
      'Vehicles.Common.ScheduleAllVehicles',
      'Vehicles.Common.ViewDashboard',
      'Vehicles.DataSetup.ManageCustomFields',
      'Vehicles.DataSetup.ManageInsurancePolicies',
      'Vehicles.DataSetup.ManageMakes',
      'Vehicles.DataSetup.ManageModels',
      'Vehicles.DataSetup.ManageRegistrationTypes',
      'Vehicles.DataSetup.ManageServiceTypes',
      'Vehicles.DataSetup.ManageTypes',
      'Vehicles.DataSetup.ManageVehicleGroups',
      'Vehicles.Trackers.ManageTrackers'
    ]
  },
  Visitors: {
    ANY: 'ANY:Visitors',
    Common: {
      ANY: 'ANY:Visitors.Common',
      DesktopVisitorModule: 'Visitors.Common.DesktopVisitorModule',
      ManageAppointments: 'Visitors.Common.ManageAppointments',
      ManageGuests: 'Visitors.Common.ManageGuests',
      ManageVisitorNotes: 'Visitors.Common.ManageVisitorNotes',
      ViewDashboard: 'Visitors.Common.ViewDashboard',
      ManageVisitorBags: 'Visitors.Common.ManageVisitorBags'
    },
    DataSetup: {
      ANY: 'ANY:Visitors.DataSetup',
      ManageSchedules: 'Visitors.DataSetup.ManageSchedules',
      ManageVisitorTypes: 'Visitors.DataSetup.ManageVisitorTypes'
    },
    Tools: {
      ANY: 'ANY:Visitors.Tools',
      ManageVisitorEBadges: 'Visitors.Tools.ManageVisitorEBadges'
    },
    ALL: [
      'Visitors.Common.DesktopVisitorModule',
      'Visitors.Common.ManageAppointments',
      'Visitors.Common.ManageGuests',
      'Visitors.Common.ManageVisitorNotes',
      'Visitors.Common.ViewDashboard',
      'Visitors.DataSetup.ManageSchedules',
      'Visitors.DataSetup.ManageVisitorTypes',
      'Visitors.Tools.ManageVisitorEBadges',
      'Visitors.Common.ManageVisitorBags'
    ]
  },
  Reception: {
    ANY: 'ANY:Reception',
    Appointments: {
      ANY: 'ANY:Reception.Appointments',
      ManageAppointments: 'Reception.Appointments.ManageAppointments',
      ViewAppointments: 'Reception.Appointments.ViewAppointments'
    }
  }
}
